<template>
	<header class="header">
		<Nav></Nav>
		<div class="content">
			<h3>个性化软件开发定制专家</h3>
			<p>
				产品定位 &nbsp; | &nbsp; 产品设计 &nbsp; | &nbsp; 代码实现 | &nbsp;
				产品上线
			</p>
		</div>
	</header>
	<div class="dingzhi">
		<div class="content">
			<!--   <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/dingzhi.png"
        alt=""
      /> -->
			<img src="./img/dingzhi.png" alt="" />
			<transition name="plus-img1">
				<img src="./img/dingzhi2.png" alt="" class="dz-img2" v-if="dzShow" />
			</transition>
			<transition name="plus-img2">
				<img src="./img/dingzhi3.png" alt="" class="dz-img3" v-if="dzShow" />
			</transition>
			<transition name="plus-img3">
				<img src="./img/dingzhi1.png" alt="" class="dz-img1" v-if="dzShow" />
			</transition>
			<div class="right">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhuanjia.png" alt="" />
				<h3>移动互联网定制专家</h3>
				<p><span class="dian"></span> 15年专注技术服务，您身边的软件定制专家</p>
				<p><span class="dian"></span> 系统定制，一站式行业解决方案</p>
				<p>专业的服务，创造有影响力的产品</p>
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/dibulogo.png" alt="" />
			</div>
		</div>
	</div>
	<div class="liucheng">
		<div class="left">
			<h3>互联网解决方案服务商</h3>
			<p>
				全流程服务保障项目交付<br />
				长期稳定迭代维护，终身技术咨询
			</p>
			<p>标准化项目实施流程</p>
		</div>
		<div class="right">
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/liucheng1.png" alt="" />
				<h5>设计阶段</h5>
				<p>
					资深项目经理，产品经理, UI设计师帮您梳理项目需求，制定项目开发方案。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/liucheng2.png" alt="" />
				<h5>开发阶段</h5>
				<p>
					高级技术研发工程师以最新的主流流程，提供专业的代码编写，高质量、高保障。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/liucheng3.png" alt="" />
				<h5>测试阶段</h5>
				<p>
					标准化测试流程，为项目最后上线工作提供保驾护航，让您的项目顺利落地。
				</p>
			</div>
		</div>
	</div>
	<div class="chanpin">
		<h3>我们为您提供的产品</h3>
		<p>不只是开发，更是优质的服务</p>
		<div class="content">
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/chanpin1.png" alt="" />
				<h5>个性化产品</h5>
				<p>
					根据客户自定义需求，结合当前用户群体，人群画像，定向开发功能及产品。了解需求后，定制可行性分析报告，制定开发形式和架构，更好的帮助客户实现功能产品。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/chanpin2.png" alt="" />
				<h5>互联网解决方案</h5>
				<p>
					通过物联网满足用户多样化需求，例如：智慧城市、智慧物业、智慧家居等，通过产品开发，来提升实际的工作效率，管理成本等。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/chanpin3.png" alt="" />
				<h5>丰富的开发经验</h5>
				<p>
					更符合当前市场的在线即时通讯系统，通讯录好友聊天、群聊、圈子功能、视频、语音通话、发送红包、群红包、充值提现、阅后即焚、满足当个环境的通讯系统。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/chanpin4.png" alt="" />
				<h5>全行业解决方案</h5>
				<p>
					更加完善的制度、算法、主播认证流程。多种礼物类型，多种身份设定。道具商城，盲盒礼物配置出现概率，发送红包，用户抢红包收益。
				</p>
			</div>
		</div>
	</div>
	<div class="hangye">
		<h3>敢于行业先，一对一产品定制开发</h3>
		<div class="content">
			<div class="liucheng">
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo1.png" alt="" />
					<p>需求分析</p>
				</div>

				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo2.png" alt="" />
					<p>原型设计</p>
				</div>
				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo3.png" alt="" />
					<p>UI设计</p>
				</div>
				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo4.png" alt="" />
					<p>程序开发</p>
				</div>
				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo5.png" alt="" />
					<p>产品测试</p>
				</div>
				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo6.png" alt="" />
					<p>项目管理</p>
				</div>
				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo7.png" alt="" />
					<p>证书申请</p>
				</div>
				<div class="xuxian"></div>
				<div class="box">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/logo8.png" alt="" />
					<p>更新维护</p>
				</div>
			</div>
			<div class="zhuanye">
				<div class="box1">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhuanye01.png" alt="" />
					<div class="right">
						<h5>多年互联网开发经验</h5>
						<p>
							提供全行业应用解决方案，为产品在不同场景中快速落地，专业团队自助研发各类网站及移动端产品，助力企业新发展
						</p>
					</div>
				</div>
				<div class="box1">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhaunye02.png" alt="" />
					<div class="right">
						<h5>高性价比的开发服务</h5>
						<p>
							高效的项目开发服务，针对不同企业的差异化需求，提供个性化、精细化解决方案，提升企业管理，提高企业经济效益。
						</p>
					</div>
				</div>
				<div class="box1">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhuanye03.png" alt="" />
					<div class="right">
						<h5>专业技术开发团队</h5>
						<p>
							拥有经验丰富的技术开发团队，快速解决项目难点，从开发到测试，从上线到运营，保障项目后期延展拓宽，
						</p>
					</div>
				</div>
				<div class="box1">
					<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/zhuanye04.png" alt="" />
					<div class="right">
						<h5>完善的售后服务体系</h5>
						<p>
							全方位支撑售前、售中、售后跟踪服务，确认及时有效解决问题，为客户提供放心、可信赖、可持续合作的软件开发服务。
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="kehu">
		<h3>我们服务的客户</h3>
		<p>超1000+客户服务案例，致力于互联网极致产品</p>
		<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/kehu.png" alt="" />
	</div>
	<Footer></Footer>
	<Onlineservice></Onlineservice>
	<Floating></Floating>
</template>

<script>
	import Nav from "../Nav.vue";
	import Footer from "../Footer.vue";
	import Floating from "../Floating.vue";
	import Onlineservice from "../Onlineservice.vue";
	export default {
		name: "Solve",
		components: {
			Nav,
			Footer,
			Floating,
			Onlineservice,
		},
		data() {
			return {
				dzShow: false,
			}
		},
		methods: {
			getScrollTop() {
				var scrollPos;
				if (window.pageYOffset) {
					scrollPos = window.pageYOffset;
				} else if (document.compatMode && document.compatMode != 'BackCompat') {
					scrollPos = document.documentElement.scrollTop;
				} else if (document.body) {
					scrollPos = document.body.scrollTop;
				}
				return scrollPos;
				// console.log(scrollPos);
			}
		},
		mounted() {
			let that = this;
			window.onscroll = function() {
				let scrollPos = that.getScrollTop();
				console.log("scrollPos：", scrollPos);
				if (scrollPos >= 100) {
					that.dzShow = true
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.plus-img1-enter-from {
		opacity: 0
	}

	.plus-img1-enter-active {
		transition: all 1.5s;
	}

	.plus-img1-enter-to {
		opcaity: 1
	}


	.plus-img2-enter-from {
		opacity: 0
	}

	.plus-img2-enter-active {
		transition: all 3s;
	}

	.plus-img2-enter-to {
		opcaity: 1
	}


	.plus-img3-enter-from {
		opacity: 0
	}

	.plus-img3-enter-active {
		transition: all 4.5s;
	}

	.plus-img3-enter-to {
		opcaity: 1
	}


	.header {
		width: 100%;
		height: 520px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/solvebg.png) no-repeat;
		background-size: cover;

		.content {
			width: 1440px;
			height: 400px;
			margin: 0 auto;
			/* background-color: white; */
			overflow: hidden;
			color: white;

			h3 {
				height: 50px;
				line-height: 50px;
				font-size: 36px;
				margin-top: 100px;
				font-weight: 540;
			}

			p {
				height: 50px;
				line-height: 50px;
				font-size: 22px;
				margin-top: 20px;
				font-weight: 400;
			}
		}
	}

	.dingzhi {
		width: 100%;
		height: 900px;
		background: #f6f7fa;
		overflow: hidden;

		.content {
			width: 1440px;
			height: 900px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: center;
			position: relative;

			img {
				display: block;
				width: 824px;
				height: 841px;
			}

			.dz-img1 {
				width: 500px;
				height: 130px;
				position: absolute;
				left: 240px;
				top: 530px;
			}

			.dz-img2 {
				width: 296px;
				height: 70px;
				position: absolute;
				left: 0px;
				top: 380px;
			}

			.dz-img3 {
				width: 296px;
				height: 70px;
				position: absolute;
				left: 20px;
				top: 465px;
			}

			.right {
				width: 500px;
				height: 900px;
				overflow: hidden;

				img:nth-child(1) {
					margin-top: 250px;
					display: block;
					width: 75px;
					height: 75px;
				}

				h3 {
					width: 500px;
					height: 50px;
					font-size: 36px;
					font-weight: 500;
					line-height: 50px;
					color: #333333;
					opacity: 1;
				}

				p {
					position: relative;
					width: 500px;
					height: 50px;
					font-size: 16px;
					font-weight: 500;
					line-height: 50px;
					color: #666666;
					opacity: 1;
					margin-left: 20px;

					.dian {
						display: block;
						position: absolute;
						width: 8px;
						height: 8px;
						background: #cccccc;
						border-radius: 50%;
						opacity: 1;
						top: 0;
						bottom: 0;
						margin: auto;
						left: -16px;
					}
				}

				p:nth-child(3) {
					margin-top: 50px;
				}

				p:nth-child(5) {
					margin-top: 100px;
					margin-left: 12px;
				}

				img:nth-child(6) {
					display: block;
					width: 433px;
					height: 33px;
					margin-left: 10px;
				}
			}
		}
	}

	.liucheng {
		width: 1440px;
		height: 780px;
		overflow: hidden;
		margin: 0 auto;
		display: flex;
		justify-content: space-around;
		align-items: center;

		.left {
			width: 400px;
			height: 580px;
			overflow: hidden;

			h3 {
				width: 500px;
				height: 50px;
				font-size: 36px;
				font-weight: 500;
				line-height: 50px;
				color: #333333;
				opacity: 1;
				margin-top: 80px;
			}

			p {
				width: 500px;
				height: 48px;
				font-size: 16px;
				font-weight: 400;
				line-height: 26px;
				color: #666666;
				opacity: 1;
				margin-top: 80px;
			}

			p:nth-child(3) {
				width: 500px;
				height: 22px;
				font-size: 16px;
				font-weight: 500;
				line-height: 22px;
				color: #e5161d;
				opacity: 1;
				margin-top: 150px;
			}
		}

		.right {
			width: 930px;
			height: 760px;
			overflow: hidden;
			display: flex;
			justify-content: space-around;
			align-items: center;

			.box {
				width: 310px;
				height: 580px;
				background: #ffffff;
				border: 1px solid #efefef;
				opacity: 0.8;
				border-radius: 5px;
				box-sizing: border-box;

				img {
					display: block;
					width: 158px;
					height: 158px;
					margin: 80px auto;
				}

				h5 {
					width: 100%;
					height: 50px;
					font-size: 26px;
					font-weight: 500;
					line-height: 50px;
					color: #333333;
					opacity: 1;
					text-align: center;
					margin-top: -20px;
				}

				p {
					width: 200px;
					height: 80px;
					font-size: 16px;
					font-weight: 400;
					line-height: 26px;
					color: #666666;
					opacity: 1;
					margin: 20px auto;
					text-align: center;
				}
			}

			.box:hover {
				width: 310px;
				height: 580px;
				background: #ffffff;
				box-shadow: 0px 3px 40px rgba(216, 216, 230, 0.36);
				opacity: 1;
				border-radius: 5px;
				z-index: 99;
			}
		}
	}

	.chanpin {
		position: relative;
		width: 100%;
		height: 450px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/chanpinbg.png) no-repeat;
		background-size: cover;

		.content {
			position: absolute;
			width: 1440px;
			height: 500px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			left: 0;
			right: 0;
			margin: 0 auto;
			bottom: -340px;

			.box {
				width: 330px;
				height: 480px;
				background: #ffffff;
				box-shadow: 0px 3px 24px rgba(170, 170, 170, 0.16);
				opacity: 1;
				border-radius: 5px;
				overflow: hidden;
				transition: all 0.5s;

				img {
					width: 68px;
					height: 68px;
					margin-top: 60px;
					margin-left: 30px;
				}

				h5 {
					width: 300px;
					height: 50px;
					font-size: 26px;
					font-weight: 500;
					line-height: 50px;
					color: #333333;
					opacity: 1;
					margin-left: 30px;
					margin-top: 50px;
				}

				p {
					width: 260px;
					font-size: 16px;
					font-weight: 400;
					line-height: 26px;
					color: #666666;
					opacity: 1;
					margin-left: 30px;
					margin-top: 20px;
				}
			}

			.box:hover {
				transform: scale(1.1);
			}
		}
	}

	.hangye {
		width: 100%;
		height: 1300px;
		background: #f6f7fa;
		overflow: hidden;

		h3 {
			width: 1440px;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			line-height: 50px;
			color: #333333;
			opacity: 1;
			margin: 0 auto;
			text-align: center;
			margin-top: 450px;
		}

		.content {
			width: 1440px;
			height: 1000px;
			margin: 0 auto;
			overflow: hidden;

			// background: #666666;
			.liucheng {
				width: 1440px;
				height: 220px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 50px;

				.box {
					width: 100px;
					height: 100px;

					img {
						display: block;
						width: 48px;
						height: 48px;
						margin: 0 auto;
					}

					p {
						width: 100%;
						width: 64px;
						height: 30px;
						font-size: 16px;
						font-weight: 400;
						line-height: 30px;
						color: #141414;
						opacity: 1;
						text-align: center;
						margin: 0 auto;
						margin-top: 14px;
					}
				}

				.xuxian {
					width: 70px;
					height: 0px;
					border: 1px dashed #333333;
					opacity: 0.2;
					margin-top: -40px;
				}
			}

			.zhuanye {
				width: 1440px;
				height: 480px;
				overflow: hidden;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				.box1 {
					width: 710px;
					height: 220px;
					background: #ffffff68;
					border: 1px solid #f8fafc;
					border-radius: 5px;
					display: flex;
					justify-content: space-around;
					align-items: center;

					img {
						display: block;
						width: 100px;
						height: 100px;
						margin-left: 20px;
					}

					.right {
						width: 550px;
						height: 120px;
						overflow: hidden;

						h5 {
							width: 100%;
							height: 50px;
							font-size: 26px;
							font-weight: 500;
							line-height: 50px;
							color: #333333;
							opacity: 1;
						}

						p {
							width: 470px;
							height: 48px;
							font-size: 16px;
							font-weight: 400;
							line-height: 26px;
							color: #666666;
							opacity: 1;
							margin-top: 10px;
						}
					}
				}

				.box1:hover {
					width: 710px;
					height: 220px;
					background: linear-gradient(129deg, #ffffff 0%, #f6f7fa 100%);
					box-shadow: 0px 3px 14px rgba(153, 153, 153, 0.16);
					opacity: 1;
					border-radius: 5px;
				}
			}
		}
	}

	.kehu {
		width: 1440px;
		height: 1100px;
		overflow: hidden;
		margin: 0 auto;

		h3 {
			width: 100%;
			text-align: center;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			line-height: 50px;
			color: #333333;
			opacity: 1;
			margin-top: 100px;
		}

		p {
			width: 100%;
			height: 20px;
			font-size: 14px;
			font-weight: 400;
			line-height: 0px;
			color: #999999;
			opacity: 1;
			text-align: center;
			margin-top: 40px;
		}

		img {
			display: block;
			width: 1440px;
			height: 714px;
			margin-top: 60px;
		}
	}
</style>
